/* Part 61 Apparel — global.js */
(function () {
  'use strict';

  /* ---------- helpers ---------- */
  function formatMoney(cents) {
    var value = (cents / 100).toFixed(2);
    var format = (window.theme && window.theme.moneyFormat) || '${{amount}}';
    return format
      .replace(/\{\{\s*amount\s*\}\}/, Number(value).toLocaleString('en-US', { minimumFractionDigits: 2 }))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100).toLocaleString('en-US'))
      .replace(/<[^>]*>/g, '');
  }

  function escapeHtml(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function imgUrl(src, width) {
    if (!src) return '';
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  function samePath(a, b) {
    if (!a || !b) return false;
    function norm(u) { return String(u).split('?')[0].replace(/^https?:/, '').replace(/^\/\//, ''); }
    return norm(a) === norm(b);
  }

  function attachSwipe(el, onLeft, onRight) {
    var startX = null, startY = null;
    el.addEventListener('touchstart', function (e) {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
    }, { passive: true });
    el.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      var dy = e.changedTouches[0].clientY - startY;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.4) {
        if (dx < 0) onLeft(); else onRight();
      }
      startX = startY = null;
    }, { passive: true });
  }

  function trapFocusContainer(el) {
    el.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var focusables = el.querySelectorAll('a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])');
      if (!focusables.length) return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  }

  /* ---------- announcement rotation ---------- */
  document.querySelectorAll('[data-announcement-track]').forEach(function (track) {
    var items = track.querySelectorAll('.announcement__item');
    if (items.length < 2) return;
    var i = 0;
    setInterval(function () {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, 4500);
  });

  /* ---------- mobile nav ---------- */
  var mobileNav = document.getElementById('MobileNav');
  document.querySelectorAll('[data-open-menu]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      mobileNav.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    });
  });
  if (mobileNav) {
    trapFocusContainer(mobileNav);
    mobileNav.querySelectorAll('[data-close-menu], .mobile-nav__overlay').forEach(function (el) {
      el.addEventListener('click', function () {
        mobileNav.classList.remove('is-open');
        document.body.style.overflow = '';
      });
    });
  }

  /* ---------- cart drawer ---------- */
  var CartDrawer = {
    root: function () { return document.getElementById('CartDrawer'); },
    open: function () {
      var root = this.root();
      if (!root) return;
      root.classList.add('is-open');
      root.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      var closeBtn = root.querySelector('[data-close-cart]');
      if (closeBtn) closeBtn.focus();
    },
    close: function () {
      var root = this.root();
      if (!root) return;
      root.classList.remove('is-open');
      root.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    },
    renderFromHTML: function (html) {
      var root = this.root();
      if (!root) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.getElementById('CartDrawer');
      if (fresh) {
        root.innerHTML = fresh.innerHTML;
        this.bind();
        this.syncCount();
        this.loadUpsells();
      }
    },
    syncCount: function () {
      var src = document.querySelector('[data-cart-count-source]');
      if (!src) return;
      var n = src.getAttribute('data-cart-count-source');
      document.querySelectorAll('.js-cart-count').forEach(function (el) {
        el.textContent = n;
        el.setAttribute('data-count', n);
      });
    },
    refresh: function (openAfter) {
      var self = this;
      fetch(window.location.pathname + '?sections=cart-drawer')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          self.renderFromHTML(data['cart-drawer']);
          if (openAfter) self.open();
        });
    },
    change: function (line, quantity) {
      var self = this;
      fetch(window.theme.routes.cartChange + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity, sections: 'cart-drawer' })
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data.sections && data.sections['cart-drawer']) self.renderFromHTML(data.sections['cart-drawer']);
        });
    },
    bind: function () {
      var root = this.root();
      if (!root) return;
      var self = this;
      root.querySelectorAll('[data-close-cart], .cart-drawer__overlay').forEach(function (el) {
        el.addEventListener('click', function () { self.close(); });
      });
      root.querySelectorAll('.cart-item').forEach(function (item) {
        var line = parseInt(item.getAttribute('data-line'), 10);
        var input = item.querySelector('.qty input');
        item.querySelectorAll('[data-qty-change]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            var delta = parseInt(btn.getAttribute('data-qty-change'), 10);
            self.change(line, Math.max(0, parseInt(input.value, 10) + delta));
          });
        });
        if (input) {
          input.addEventListener('change', function () {
            self.change(line, Math.max(0, parseInt(input.value, 10) || 0));
          });
        }
        var remove = item.querySelector('[data-remove-item]');
        if (remove) remove.addEventListener('click', function () { self.change(line, 0); });
      });
    },
    loadUpsells: function () {
      var box = document.querySelector('[data-cart-upsells]');
      if (!box) return;
      var productId = box.getAttribute('data-first-product');
      if (!productId) { box.hidden = true; return; }
      var inCart = (box.getAttribute('data-cart-products') || '').split(',');
      fetch(window.theme.routes.recommendations + '.json?product_id=' + productId + '&limit=6&intent=related')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var products = (data.products || []).filter(function (p) {
            return inCart.indexOf(String(p.id)) === -1 && p.available;
          }).slice(0, 3);
          if (!products.length) { box.hidden = true; return; }
          var list = box.querySelector('[data-upsell-list]');
          list.innerHTML = products.map(function (p) {
            var v = p.variants && p.variants.length ? p.variants[0] : null;
            var img = p.featured_image ? imgUrl(p.featured_image, 120) : '';
            var btnHtml = '';
            if (p.variants && p.variants.length > 1) {
              btnHtml = '<button class="cart-upsell__add" data-quick-shop="' + p.handle + '">Add +</button>';
            } else if (v) {
              btnHtml = '<button class="cart-upsell__add" data-upsell-add="' + v.id + '">Add +</button>';
            }
            return '<div class="cart-upsell">' +
              '<img src="' + img + '" alt="" width="56" height="56" loading="lazy">' +
              '<div><a class="cart-upsell__title" href="' + p.url + '">' + escapeHtml(p.title) + '</a>' +
              '<div class="cart-upsell__price">' + formatMoney(p.price) + '</div></div>' +
              btnHtml +
              '</div>';
          }).join('');
          box.hidden = false;
          list.querySelectorAll('[data-upsell-add]').forEach(function (btn) {
            btn.addEventListener('click', function () {
              btn.disabled = true;
              btn.textContent = 'Adding…';
              addToCart(btn.getAttribute('data-upsell-add'), 1);
            });
          });
        })
        .catch(function () { box.hidden = true; });
    }
  };
  CartDrawer.bind();
  CartDrawer.loadUpsells();

  document.querySelectorAll('[data-open-cart]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      CartDrawer.open();
    });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      CartDrawer.close();
      closeQuickShop();
      if (mobileNav) { mobileNav.classList.remove('is-open'); document.body.style.overflow = ''; }
      var facetsOpen = document.querySelector('[data-facets].is-open');
      if (facetsOpen) { facetsOpen.classList.remove('is-open'); document.body.style.overflow = ''; }
      var popup = document.getElementById('NlPopup');
      if (popup) popup.classList.remove('is-open');
    }
  });
  var drawerRoot = CartDrawer.root();
  if (drawerRoot) trapFocusContainer(drawerRoot);

  /* ---------- add to cart ---------- */
  function addItemsToCart(items, button) {
    if (button) button.classList.add('is-loading');
    return fetch(window.theme.routes.cartAdd + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items, sections: 'cart-drawer' })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (button) button.classList.remove('is-loading');
        if (data.status && data.status !== 200) {
          alert(data.description || 'Could not add to cart.');
          return;
        }
        if (window.theme.cartType === 'page') {
          window.location.href = window.theme.routes.cart;
          return;
        }
        if (data.sections && data.sections['cart-drawer']) {
          CartDrawer.renderFromHTML(data.sections['cart-drawer']);
          CartDrawer.open();
        } else {
          CartDrawer.refresh(true);
        }
      })
      .catch(function () {
        if (button) button.classList.remove('is-loading');
      });
  }
  function addToCart(variantId, quantity, button) {
    return addItemsToCart([{ id: Number(variantId), quantity: quantity || 1 }], button);
  }
  window.p61AddToCart = addToCart;
  window.p61AddItems = addItemsToCart;

  /* product form (main product page) */
  document.querySelectorAll('form[data-product-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var id = form.querySelector('[name="id"]').value;
      var qtyEl = form.querySelector('[name="quantity"]');
      var qty = qtyEl ? parseInt(qtyEl.value, 10) || 1 : 1;
      addToCart(id, qty, form.querySelector('[type="submit"]'));
    });
  });

  /* quick add on cards */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-quick-add-toggle]');
    if (toggle) {
      e.preventDefault();
      var qa = toggle.closest('.quick-add');
      var variantId = toggle.getAttribute('data-variant-id');
      if (variantId) {
        addToCart(variantId, 1, toggle);
      } else {
        document.querySelectorAll('.quick-add.is-open').forEach(function (o) { o.classList.remove('is-open'); });
        qa.classList.add('is-open');
      }
      return;
    }
    var option = e.target.closest('[data-quick-add-variant]');
    if (option) {
      e.preventDefault();
      addToCart(option.getAttribute('data-quick-add-variant'), 1);
      option.closest('.quick-add').classList.remove('is-open');
      return;
    }
    if (!e.target.closest('.quick-add')) {
      document.querySelectorAll('.quick-add.is-open').forEach(function (o) { o.classList.remove('is-open'); });
    }
  });

  /* one-tap add from the drawer's "complete your pack" row (Liquid-rendered, survives drawer refresh) */
  document.addEventListener('click', function (e) {
    var packBtn = e.target.closest('[data-pack-add-variant]');
    if (!packBtn) return;
    e.preventDefault();
    packBtn.disabled = true;
    packBtn.textContent = 'Adding\u2026';
    addToCart(packBtn.getAttribute('data-pack-add-variant'), 1);
  });

  /* ---------- variant picker (product page) ---------- */
  var picker = document.querySelector('[data-variant-picker]');
  if (picker) {
    var variantData = JSON.parse(document.getElementById('ProductVariants').textContent);
    var priceEl = document.querySelector('[data-product-price]');
    var comparePriceEl = document.querySelector('[data-compare-price]');
    var idInput = document.querySelector('form[data-product-form] [name="id"]');
    var atcBtn = document.querySelector('[data-atc-button]');
    var stickyId = document.querySelector('[data-sticky-variant-id]');

    function currentOptions() {
      var opts = [];
      picker.querySelectorAll('.option-values').forEach(function (group) {
        var checked = group.querySelector('input:checked');
        opts.push(checked ? checked.value : null);
      });
      return opts;
    }
    function findVariant(opts) {
      return variantData.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }
    picker.addEventListener('change', function () {
      var variant = findVariant(currentOptions());
      if (!variant) return;
      idInput.value = variant.id;
      if (stickyId) stickyId.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (comparePriceEl) {
        if (window.theme.showCompareAt === true && variant.compare_at_price && variant.compare_at_price > variant.price) {
          comparePriceEl.textContent = formatMoney(variant.compare_at_price);
          comparePriceEl.hidden = false;
          priceEl.classList.add('sale');
        } else {
          comparePriceEl.hidden = true;
          priceEl.classList.remove('sale');
        }
      }
      if (atcBtn) {
        var label = atcBtn.querySelector('.btn-label');
        if (variant.available) {
          atcBtn.disabled = false;
          if (label) label.textContent = atcBtn.getAttribute('data-label-add');
        } else {
          atcBtn.disabled = true;
          if (label) label.textContent = 'Sold out';
        }
      }
      if ((variant.featured_media || variant.featured_image) && Gallery) {
        Gallery.selectByVariant(variant);
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    });
  }

  /* ---------- product gallery (media items, vertical rail, arrows, swipe) ---------- */
  function initGallery(frame) {
    var mainWrap = frame.querySelector('[data-gallery-main]');
    var items = Array.prototype.slice.call(frame.querySelectorAll('[data-gallery-item]'));
    var thumbs = Array.prototype.slice.call(frame.querySelectorAll('[data-gallery-thumb]'));
    var index = 0;

    function show(i) {
      if (!items.length) return;
      index = (i + items.length) % items.length;
      items.forEach(function (item, ii) {
        var active = ii === index;
        item.classList.toggle('is-active', active);
        if (!active) {
          item.querySelectorAll('video').forEach(function (v) { v.pause(); });
        }
      });
      thumbs.forEach(function (t, ti) { t.classList.toggle('is-active', ti === index); });
      var thumb = thumbs[index];
      if (thumb && thumb.scrollIntoView) thumb.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
    }

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () { show(i); });
    });
    var prev = frame.querySelector('[data-gallery-prev]');
    var next = frame.querySelector('[data-gallery-next]');
    if (prev) prev.addEventListener('click', function () { show(index - 1); });
    if (next) next.addEventListener('click', function () { show(index + 1); });
    if (mainWrap) attachSwipe(mainWrap, function () { show(index + 1); }, function () { show(index - 1); });

    return {
      selectByVariant: function (variant) {
        var mediaId = variant.featured_media && variant.featured_media.id;
        var img = variant.featured_image;
        for (var i = 0; i < items.length; i++) {
          var idAttr = items[i].getAttribute('data-media-id');
          if (mediaId && idAttr && String(mediaId) === idAttr) { show(i); return true; }
        }
        if (img && img.src) {
          for (var j = 0; j < items.length; j++) {
            var itemImg = items[j].querySelector('img');
            if (itemImg && samePath(itemImg.currentSrc || itemImg.src, img.src)) { show(j); return true; }
          }
        }
        return false;
      }
    };
  }

  document.querySelectorAll('[data-gallery]').forEach(function (frame) {
    frame.__galleryApi = initGallery(frame);
  });
  var Gallery = (function () {
    var pdpFrame = document.querySelector('.product [data-gallery]');
    return pdpFrame ? pdpFrame.__galleryApi : null;
  })();

  /* ---------- sticky ATC bar ---------- */
  var stickyBar = document.getElementById('StickyAtc');
  var mainBuy = document.querySelector('[data-atc-button]');
  if (stickyBar && mainBuy && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      stickyBar.classList.toggle('is-visible', !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0);
    }, { threshold: 0 });
    io.observe(mainBuy);
    var stickyForm = stickyBar.querySelector('form');
    if (stickyForm) {
      stickyForm.addEventListener('submit', function (e) {
        e.preventDefault();
        addToCart(stickyForm.querySelector('[name="id"]').value, 1, stickyForm.querySelector('button'));
      });
    }
  }

  /* ---------- qty selectors outside drawer ---------- */
  document.querySelectorAll('[data-qty-wrap]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    wrap.querySelectorAll('button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var delta = parseInt(btn.getAttribute('data-delta'), 10);
        input.value = Math.max(1, (parseInt(input.value, 10) || 1) + delta);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  /* ---------- facets auto-submit ---------- */
  var facetsForm = document.getElementById('FacetsForm');
  if (facetsForm) {
    facetsForm.querySelectorAll('input[type="checkbox"], select[name="sort_by"]').forEach(function (el) {
      el.addEventListener('change', function () { facetsForm.submit(); });
    });
  }
  var sortSelect = document.getElementById('SortBy');
  if (sortSelect && !facetsForm) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      window.location.href = url.toString();
    });
  }

  /* ---------- recently viewed ---------- */
  try {
    var KEY = 'p61_recent';
    var meta = document.getElementById('ProductMeta');
    var recent = JSON.parse(localStorage.getItem(KEY) || '[]');
    if (meta) {
      var p = JSON.parse(meta.textContent);
      recent = recent.filter(function (r) { return r.handle !== p.handle; });
      recent.unshift(p);
      recent = recent.slice(0, 8);
      localStorage.setItem(KEY, JSON.stringify(recent));
    }
    var rvSection = document.querySelector('[data-recently-viewed]');
    if (rvSection) {
      var currentHandle = meta ? JSON.parse(meta.textContent).handle : null;
      var items = recent.filter(function (r) { return r.handle !== currentHandle; }).slice(0, 4);
      if (items.length) {
        var grid = rvSection.querySelector('[data-rv-grid]');
        grid.innerHTML = items.map(function (r) {
          return '<div class="product-card">' +
            '<div class="product-card__media"><img src="' + r.image + '" alt="" loading="lazy"></div>' +
            '<div class="product-card__info">' +
            '<a class="product-card__title" href="' + r.url + '">' + r.title + '</a>' +
            '<div class="product-card__price">' + r.price + '</div>' +
            '</div></div>';
        }).join('');
        rvSection.hidden = false;
      }
    }
  } catch (err) { /* localStorage unavailable */ }

  /* ---------- newsletter popup ---------- */
  var popup = document.getElementById('NlPopup');
  if (popup) {
    var delay = parseInt(popup.getAttribute('data-delay'), 10) || 8;
    var KEY_NL = 'p61_nl_dismissed';
    var dismissed = false;
    try { dismissed = localStorage.getItem(KEY_NL) === '1'; } catch (e) {}
    var isSignupSuccess = window.location.search.indexOf('customer_posted=true') !== -1;
    if (!dismissed && !isSignupSuccess && document.body.classList.contains('template-index')) {
      setTimeout(function () { popup.classList.add('is-open'); }, delay * 1000);
    }
    popup.querySelectorAll('[data-close-popup], .nl-popup__overlay').forEach(function (el) {
      el.addEventListener('click', function () {
        popup.classList.remove('is-open');
        try { localStorage.setItem(KEY_NL, '1'); } catch (e) {}
      });
    });
  }

  /* ---------- seamless ticker ---------- */
  document.querySelectorAll('[data-ticker]').forEach(function (inner) {
    var groups = inner.querySelectorAll('.ticker__group');
    if (groups.length < 2) return;
    var base = groups[0];
    if (!base.children.length) return;
    var originals = Array.prototype.slice.call(base.children);
    var guard = 0;
    // Ensure one group is at least as wide as the viewport so the loop never shows a gap
    while (base.scrollWidth < window.innerWidth + 100 && guard < 12) {
      originals.forEach(function (item) {
        groups.forEach(function (g) { g.appendChild(item.cloneNode(true)); });
      });
      guard++;
    }
    // Constant scroll speed regardless of content length
    var pxPerSecond = 65;
    inner.style.animationDuration = Math.max(12, Math.round(base.scrollWidth / pxPerSecond)) + 's';
  });

  /* ---------- mobile facets drawer ---------- */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-open-facets]')) {
      var f = document.querySelector('[data-facets]');
      if (f) { f.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
      return;
    }
    if (e.target.closest('[data-close-facets]')) {
      var f2 = document.querySelector('[data-facets]');
      if (f2) { f2.classList.remove('is-open'); document.body.style.overflow = ''; }
      return;
    }
    var fRoot = document.querySelector('[data-facets].is-open');
    if (fRoot && e.target === fRoot) {
      fRoot.classList.remove('is-open'); document.body.style.overflow = '';
    }
  });

  /* ---------- quick shop modal ---------- */
  var qsRoot = document.getElementById('QuickShop');
  var qsCache = {};

  function closeQuickShop() {
    if (!qsRoot) return;
    qsRoot.classList.remove('is-open');
    qsRoot.setAttribute('aria-hidden', 'true');
    if (!document.querySelector('.cart-drawer.is-open')) document.body.style.overflow = '';
  }

  function openQuickShop(handle) {
    if (!qsRoot || !handle) return;
    qsRoot.classList.add('is-open');
    qsRoot.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var content = qsRoot.querySelector('[data-qs-content]');
    content.innerHTML = '<div class="qs-loading">Loading&hellip;</div>';
    var load = qsCache[handle]
      ? Promise.resolve(qsCache[handle])
      : fetch('/products/' + handle + '.js')
          .then(function (r) { if (!r.ok) throw new Error('not ok'); return r.json(); })
          .then(function (p) { qsCache[handle] = p; return p; });
    load
      .then(function (p) { renderQuickShop(content, p); })
      .catch(function () { content.innerHTML = '<div class="qs-loading">Could not load product. <a href="/products/' + handle + '">View product page</a></div>'; });
  }

  function renderQuickShop(content, p) {
    var optionNames = (p.options || []).map(function (o) { return typeof o === 'string' ? o : o.name; });
    function vOpt(v, i) { return v['option' + (i + 1)] !== undefined ? v['option' + (i + 1)] : (v.options ? v.options[i] : null); }

    var initial = null;
    for (var i = 0; i < p.variants.length; i++) { if (p.variants[i].available) { initial = p.variants[i]; break; } }
    initial = initial || p.variants[0];

    var optionsHtml = '';
    var hasRealOptions = !(p.variants.length === 1 && p.variants[0].title === 'Default Title');
    if (hasRealOptions) {
      optionNames.forEach(function (name, oi) {
        var values = [];
        p.variants.forEach(function (v) {
          var val = vOpt(v, oi);
          if (val != null && values.indexOf(val) === -1) values.push(val);
        });
        var isColor = /^colou?r$/i.test(name);
        optionsHtml += '<div class="option-group"><div class="option-group__label"><span>' + escapeHtml(name) + '</span></div><div class="option-values' + (isColor ? ' option-values--swatches' : '') + '">';
        values.forEach(function (val, vi) {
          var id = 'QsOpt-' + oi + '-' + vi;
          var checked = vOpt(initial, oi) === val ? ' checked' : '';
          optionsHtml += '<input type="radio" id="' + id + '" name="qs-option-' + oi + '" value="' + escapeHtml(val) + '"' + checked + '>';
          var swatchSrc = null;
          if (isColor) {
            for (var k = 0; k < p.variants.length; k++) {
              var v2 = p.variants[k];
              if (vOpt(v2, oi) === val && v2.featured_image && v2.featured_image.src) { swatchSrc = v2.featured_image.src; break; }
            }
          }
          if (swatchSrc) {
            optionsHtml += '<label for="' + id + '" class="swatch" title="' + escapeHtml(val) + '"><img src="' + imgUrl(swatchSrc, 160) + '" alt="' + escapeHtml(val) + '"></label>';
          } else {
            optionsHtml += '<label for="' + id + '">' + escapeHtml(val) + '</label>';
          }
        });
        optionsHtml += '</div></div>';
      });
    }

    var images = (p.images || []).slice(0, 8);
    var initIdx = 0;
    if (initial.featured_image && initial.featured_image.src) {
      for (var ii = 0; ii < images.length; ii++) {
        if (samePath(images[ii], initial.featured_image.src)) { initIdx = ii; break; }
      }
    }
    var mainSrc = images[initIdx] || (initial.featured_image && initial.featured_image.src) || p.featured_image || '';
    var thumbsHtml = images.map(function (src, idx) {
      return '<button type="button" data-qs-thumb data-index="' + idx + '" data-full="' + imgUrl(src, 1100) + '" class="' + (idx === initIdx ? 'is-active' : '') + '" aria-label="View image ' + (idx + 1) + '"><img src="' + imgUrl(src, 160) + '" alt="" loading="lazy"></button>';
    }).join('');

    var compareOn = window.theme.showCompareAt === true;
    var onSale = compareOn && initial.compare_at_price && initial.compare_at_price > initial.price;
    content.innerHTML =
      '<div class="qs-grid">' +
        '<div class="qs-gallery' + (images.length > 1 ? '' : ' qs-gallery--single') + '">' +
          (images.length > 1 ? '<div class="qs-thumbs">' + thumbsHtml + '</div>' : '') +
          '<div class="qs-gallery__main" data-qs-gallery-main><img data-qs-main src="' + imgUrl(mainSrc, 1100) + '" alt="' + escapeHtml(p.title) + '">' +
            (images.length > 1
              ? '<button type="button" class="gallery-nav gallery-nav--prev" data-qs-prev aria-label="Previous image"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" aria-hidden="true"><path d="m14.5 5.5-6.5 6.5 6.5 6.5"/></svg></button>' +
                '<button type="button" class="gallery-nav gallery-nav--next" data-qs-next aria-label="Next image"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" aria-hidden="true"><path d="m9.5 5.5 6.5 6.5-6.5 6.5"/></svg></button>'
              : '') +
          '</div>' +
        '</div>' +
        '<div class="qs-info product-info">' +
          '<span class="product-info__vendor">PART 61 APPAREL</span>' +
          '<h2>' + escapeHtml(p.title) + '</h2>' +
          '<p class="product-info__price">' +
            '<span data-qs-price' + (onSale ? ' class="sale"' : '') + '>' + formatMoney(initial.price) + '</span> ' +
            '<s data-qs-compare' + (onSale ? '' : ' hidden') + '>' + (initial.compare_at_price ? formatMoney(initial.compare_at_price) : '') + '</s>' +
          '</p>' +
          optionsHtml +
          '<div class="buy-row">' +
            '<div class="qty"><button type="button" data-qs-delta="-1" aria-label="Decrease quantity">−</button><input type="number" value="1" min="1" aria-label="Quantity" data-qs-qty><button type="button" data-qs-delta="1" aria-label="Increase quantity">+</button></div>' +
            '<button type="button" class="btn btn--primary btn--full" data-qs-atc' + (initial.available ? '' : ' disabled') + '><span class="btn-label">' + (initial.available ? 'Add to cart' : 'Sold out') + '</span><span class="spinner" aria-hidden="true"></span></button>' +
          '</div>' +
          '<a class="qs-link" href="' + escapeHtml(p.url || ('/products/' + p.handle)) + '">View full details &rarr;</a>' +
        '</div>' +
      '</div>';

    var current = initial;
    var mainImg = content.querySelector('[data-qs-main]');
    var priceEl = content.querySelector('[data-qs-price]');
    var compareEl = content.querySelector('[data-qs-compare]');
    var atc = content.querySelector('[data-qs-atc]');
    var qtyInput = content.querySelector('[data-qs-qty]');
    var qsThumbs = Array.prototype.slice.call(content.querySelectorAll('[data-qs-thumb]'));
    var qsIndex = initIdx;

    function qsShow(i) {
      if (!images.length || !mainImg) return;
      qsIndex = (i + images.length) % images.length;
      mainImg.src = imgUrl(images[qsIndex], 1100);
      qsThumbs.forEach(function (t) { t.classList.remove('is-active'); });
      if (qsThumbs[qsIndex]) {
        qsThumbs[qsIndex].classList.add('is-active');
        if (qsThumbs[qsIndex].scrollIntoView) qsThumbs[qsIndex].scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      }
    }

    content.querySelectorAll('[data-qs-delta]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var delta = parseInt(btn.getAttribute('data-qs-delta'), 10);
        qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + delta);
      });
    });

    content.addEventListener('change', function (e) {
      if (!e.target.matches('input[type="radio"]')) return;
      var opts = [];
      optionNames.forEach(function (_, oi) {
        var c = content.querySelector('input[name="qs-option-' + oi + '"]:checked');
        opts.push(c ? c.value : null);
      });
      var variant = p.variants.find(function (v) {
        return opts.every(function (o, idx) { return o === null || vOpt(v, idx) === o; });
      });
      if (!variant) return;
      current = variant;
      priceEl.textContent = formatMoney(variant.price);
      if (compareOn && variant.compare_at_price && variant.compare_at_price > variant.price) {
        compareEl.textContent = formatMoney(variant.compare_at_price);
        compareEl.hidden = false;
        priceEl.classList.add('sale');
      } else {
        compareEl.hidden = true;
        priceEl.classList.remove('sale');
      }
      if (variant.featured_image && variant.featured_image.src) {
        var found = -1;
        for (var fi = 0; fi < images.length; fi++) {
          if (samePath(images[fi], variant.featured_image.src)) { found = fi; break; }
        }
        if (found > -1) { qsShow(found); }
        else if (mainImg) {
          mainImg.src = imgUrl(variant.featured_image.src, 1100);
          qsThumbs.forEach(function (t) { t.classList.remove('is-active'); });
        }
      }
      var label = atc.querySelector('.btn-label');
      atc.disabled = !variant.available;
      if (label) label.textContent = variant.available ? 'Add to cart' : 'Sold out';
    });

    qsThumbs.forEach(function (t) {
      t.addEventListener('click', function () { qsShow(parseInt(t.getAttribute('data-index'), 10) || 0); });
    });
    var qsPrev = content.querySelector('[data-qs-prev]');
    var qsNext = content.querySelector('[data-qs-next]');
    if (qsPrev) qsPrev.addEventListener('click', function () { qsShow(qsIndex - 1); });
    if (qsNext) qsNext.addEventListener('click', function () { qsShow(qsIndex + 1); });
    var qsMainWrap = content.querySelector('[data-qs-gallery-main]');
    if (qsMainWrap) attachSwipe(qsMainWrap, function () { qsShow(qsIndex + 1); }, function () { qsShow(qsIndex - 1); });

    atc.addEventListener('click', function () {
      addToCart(current.id, parseInt(qtyInput.value, 10) || 1, atc).then(function () {
        closeQuickShop();
      });
    });
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-quick-shop]');
    if (trigger) {
      e.preventDefault();
      openQuickShop(trigger.getAttribute('data-quick-shop'));
      return;
    }
    if (e.target.closest('[data-close-quickshop]')) {
      closeQuickShop();
    }
  });
  if (qsRoot) trapFocusContainer(qsRoot);

  /* ---------- bundle deal: curated 4-tee packs ---------- */
  (function () {
    var SIZE_ORDER = ['XS', 'S', 'M', 'L', 'XL', 'XXL', '2XL', 'XXXL', '3XL', '4XL', '5XL'];

    document.querySelectorAll('[data-bundle-pack]').forEach(function (pack, packIndex) {
      var dataEl = pack.querySelector('[data-pack-data]');
      if (!dataEl) return;
      var data;
      try { data = JSON.parse(dataEl.textContent); } catch (err) { return; }
      var products = data.products || [];
      if (products.length < 4) return;

      var chipsWrap = pack.querySelector('[data-pack-sizes]');
      var sizeRow = pack.querySelector('[data-pack-size-row]');
      var addBtn = pack.querySelector('[data-pack-add]');
      var totalEl = pack.querySelector('[data-pack-total]');
      var dealEl = pack.querySelector('[data-pack-deal]');
      var chosen = null;

      /* --- one-tee-at-a-time carousel (arrows + dots + swipe, wraps around) --- */
      var track = pack.querySelector('[data-pack-track]');
      var slides = pack.querySelectorAll('[data-pack-slide]');
      var dots = pack.querySelectorAll('[data-pack-dot]');
      var viewport = pack.querySelector('[data-pack-viewport]');
      var slideIdx = 0;
      function goSlide(n) {
        if (!track || !slides.length) return;
        slideIdx = ((n % slides.length) + slides.length) % slides.length;
        track.style.transform = slideIdx === 0 ? '' : 'translateX(-' + (slideIdx * 100) + '%)';
        slides.forEach(function (s, i) {
          var active = i === slideIdx;
          s.classList.toggle('is-active', active);
          s.setAttribute('aria-hidden', active ? 'false' : 'true');
          var media = s.querySelector('.pack-slide__media');
          if (media) media.tabIndex = active ? 0 : -1;
        });
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === slideIdx); });
      }
      var prevBtn = pack.querySelector('[data-pack-prev]');
      var nextBtn = pack.querySelector('[data-pack-next]');
      if (prevBtn) prevBtn.addEventListener('click', function () { goSlide(slideIdx - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { goSlide(slideIdx + 1); });
      dots.forEach(function (d, i) { d.addEventListener('click', function () { goSlide(i); }); });
      if (viewport) attachSwipe(viewport, function () { goSlide(slideIdx + 1); }, function () { goSlide(slideIdx - 1); });
      goSlide(0);

      function sizeIndexOf(p) {
        var opts = p.options || [];
        for (var i = 0; i < opts.length; i++) {
          if (/^size$/i.test(String(opts[i]).trim())) return i;
        }
        return -1;
      }
      function availSizes(p) {
        var si = sizeIndexOf(p);
        if (si === -1) return null; /* no size option: never constrains the pack */
        var out = [];
        p.variants.forEach(function (v) {
          var val = v.options && v.options[si];
          if (v.available && val != null && out.indexOf(val) === -1) out.push(val);
        });
        return out;
      }
      function variantFor(p, size) {
        var si = sizeIndexOf(p);
        var i;
        if (si === -1 || size == null) {
          for (i = 0; i < p.variants.length; i++) { if (p.variants[i].available) return p.variants[i]; }
          return null;
        }
        for (i = 0; i < p.variants.length; i++) {
          var v = p.variants[i];
          if (v.available && v.options && v.options[si] === size) return v;
        }
        return null;
      }
      function updateTotal() {
        var total = 0;
        var minPrice = null;
        var ok = true;
        products.forEach(function (p) {
          var v = variantFor(p, chosen);
          if (!v) { ok = false; return; }
          total += v.price;
          if (minPrice === null || v.price < minPrice) minPrice = v.price;
        });
        if (ok) {
          if (totalEl) totalEl.textContent = formatMoney(total);
          if (dealEl) dealEl.textContent = formatMoney(total - (minPrice || 0));
        }
        if (addBtn) addBtn.disabled = !ok;
      }

      /* sizes carried by ALL 4 (products without a Size option never constrain) */
      var common = null;
      products.forEach(function (p) {
        var s = availSizes(p);
        if (s === null) return;
        if (common === null) { common = s.slice(); }
        else {
          common = common.filter(function (x) { return s.indexOf(x) !== -1; });
        }
      });

      if (common === null) {
        /* no sized products in the pack — hide the size row entirely */
        if (sizeRow) sizeRow.style.display = 'none';
        updateTotal();
      } else if (!common.length) {
        if (chipsWrap) chipsWrap.innerHTML = '<span class="pack-card__oos">No common size in stock</span>';
        if (addBtn) {
          addBtn.disabled = true;
          var lbl = addBtn.querySelector('.btn-label');
          if (lbl) lbl.textContent = 'Sold out';
        }
      } else {
        common.sort(function (a, b) {
          var ia = SIZE_ORDER.indexOf(String(a).toUpperCase());
          var ib = SIZE_ORDER.indexOf(String(b).toUpperCase());
          if (ia === -1 && ib === -1) return 0;
          if (ia === -1) return 1;
          if (ib === -1) return -1;
          return ia - ib;
        });
        chosen = common.indexOf('L') !== -1 ? 'L' : (common.indexOf('M') !== -1 ? 'M' : common[0]);
        chipsWrap.innerHTML = common.map(function (s, i) {
          var id = 'PackSize-' + packIndex + '-' + i;
          return '<input type="radio" id="' + id + '" name="pack-size-' + packIndex + '" value="' + escapeHtml(s) + '"' + (s === chosen ? ' checked' : '') + '>' +
            '<label for="' + id + '">' + escapeHtml(s) + '</label>';
        }).join('');
        chipsWrap.addEventListener('change', function (e) {
          if (!e.target.matches('input')) return;
          chosen = e.target.value;
          updateTotal();
        });
        updateTotal();
      }

      if (addBtn) {
        addBtn.addEventListener('click', function () {
          var items = [];
          for (var i = 0; i < products.length; i++) {
            var v = variantFor(products[i], chosen);
            if (!v) return;
            items.push({ id: v.id, quantity: 1 });
          }
          addItemsToCart(items, addBtn);
        });
      }
    });

    /* --- outer pack carousel (mobile): snap scroller + synced dots/counter --- */
    var raf = window.requestAnimationFrame || function (fn) { fn(); };
    document.querySelectorAll('[data-pack-scroller]').forEach(function (scroller) {
      var nav = scroller.parentNode ? scroller.parentNode.querySelector('[data-pack-scroller-nav]') : null;
      var cards = scroller.querySelectorAll('.pack-card');
      if (!nav || cards.length < 2) return;
      var dotsWrap = nav.querySelector('[data-pack-scroller-dots]');
      var countEl = nav.querySelector('[data-pack-scroller-count]');
      if (!dotsWrap) return;
      var current = 0;
      var html = '';
      for (var i = 0; i < cards.length; i++) {
        html += '<button type="button" class="pack-nav__dot' + (i === 0 ? ' is-active' : '') + '" aria-label="Show pack ' + (i + 1) + ' of ' + cards.length + '"></button>';
      }
      dotsWrap.innerHTML = html;
      var dots = dotsWrap.querySelectorAll('button');
      function setCurrent(n, scrollThere) {
        current = Math.max(0, Math.min(cards.length - 1, n));
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === current); });
        if (countEl) countEl.textContent = (current + 1) + '/' + cards.length;
        if (scrollThere) {
          var target = cards[current].offsetLeft - cards[0].offsetLeft;
          if (scroller.scrollTo) scroller.scrollTo({ left: target, behavior: 'smooth' });
          else scroller.scrollLeft = target;
        }
      }
      dots.forEach(function (d, i) {
        d.addEventListener('click', function () { setCurrent(i, true); });
      });
      var navPrev = nav.querySelector('[data-pack-nav-prev]');
      var navNext = nav.querySelector('[data-pack-nav-next]');
      if (navPrev) navPrev.addEventListener('click', function () { setCurrent((current - 1 + cards.length) % cards.length, true); });
      if (navNext) navNext.addEventListener('click', function () { setCurrent((current + 1) % cards.length, true); });
      var ticking = false;
      scroller.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        raf(function () {
          ticking = false;
          var step = cards[1].offsetLeft - cards[0].offsetLeft;
          if (step <= 0) return;
          setCurrent(Math.round(scroller.scrollLeft / step), false);
        });
      }, { passive: true });
      setCurrent(0, false);
      nav.classList.add('is-ready');
    });
  })();

  /* ---------- hero slideshow ---------- */
  document.querySelectorAll('[data-hero-slideshow]').forEach(function (root) {
    var slides = root.querySelectorAll('.hero__slide');
    if (slides.length < 2) return;
    var dots = root.querySelectorAll('[data-hero-dot]');
    var interval = (parseInt(root.getAttribute('data-interval'), 10) || 5) * 1000;
    var idx = 0;
    var timer = null;

    function go(i) {
      idx = (i + slides.length) % slides.length;
      slides.forEach(function (s, si) { s.classList.toggle('is-active', si === idx); });
      dots.forEach(function (d, di) { d.classList.toggle('is-active', di === idx); });
    }
    function start() { stop(); timer = setInterval(function () { go(idx + 1); }, interval); }
    function stop() { if (timer) clearInterval(timer); timer = null; }

    var prev = root.querySelector('[data-hero-prev]');
    var next = root.querySelector('[data-hero-next]');
    if (prev) prev.addEventListener('click', function () { go(idx - 1); start(); });
    if (next) next.addEventListener('click', function () { go(idx + 1); start(); });
    dots.forEach(function (d, di) { d.addEventListener('click', function () { go(di); start(); }); });
    attachSwipe(root, function () { go(idx + 1); start(); }, function () { go(idx - 1); start(); });
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    if (!window.matchMedia || !window.matchMedia('(prefers-reduced-motion: reduce)').matches) start();
  });

  /* ---------- scroll reveal animations ---------- */
  if (window.theme.enableAnimations && 'IntersectionObserver' in window &&
      (!window.matchMedia || !window.matchMedia('(prefers-reduced-motion: reduce)').matches)) {
    var revealTargets = document.querySelectorAll(
      '.product-card, .value-prop, .testimonial, .brand-story__grid > *, .article-card, .drop-countdown__grid > *, .newsletter__grid > *'
    );
    var revealIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          revealIO.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    revealTargets.forEach(function (el, i) {
      el.classList.add('reveal-init');
      el.style.transitionDelay = Math.min(i % 4, 3) * 60 + 'ms';
      revealIO.observe(el);
    });
  }

  /* ---------- estimated delivery dates ---------- */
  document.querySelectorAll('[data-delivery-estimate]').forEach(function (el) {
    var min = parseInt(el.getAttribute('data-min'), 10) || 3;
    var max = parseInt(el.getAttribute('data-max'), 10) || 6;
    function fmt(daysOut) {
      var d = new Date();
      d.setDate(d.getDate() + daysOut);
      if (d.getDay() === 0) d.setDate(d.getDate() + 1); // skip Sunday
      return d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
    }
    var target = el.querySelector('[data-delivery-text]');
    if (target) {
      var template = el.getAttribute('data-text') || 'Order today - estimated delivery [min_date] to [max_date]';
      target.innerHTML = escapeHtml(template)
        .replace('[min_date]', '<strong>' + fmt(min) + '</strong>')
        .replace('[max_date]', '<strong>' + fmt(max) + '</strong>');
      el.hidden = false;
    }
  });

  /* ---------- drop countdown ---------- */
  document.querySelectorAll('[data-countdown]').forEach(function (root) {
    var raw = root.getAttribute('data-date');
    if (!raw) return;
    var target = new Date(raw.replace(' ', 'T'));
    if (isNaN(target.getTime())) return;
    var d = root.querySelector('[data-cd-days]');
    var h = root.querySelector('[data-cd-hours]');
    var m = root.querySelector('[data-cd-mins]');
    var s = root.querySelector('[data-cd-secs]');
    function tick() {
      var diff = target.getTime() - Date.now();
      if (diff <= 0) {
        root.classList.add('is-expired');
        root.innerHTML = '<div class="drop-countdown__unit"><strong>' + escapeHtml(root.getAttribute('data-expired') || 'LIVE NOW') + '</strong></div>';
        clearInterval(timer);
        return;
      }
      var secs = Math.floor(diff / 1000);
      if (d) d.textContent = Math.floor(secs / 86400);
      if (h) h.textContent = String(Math.floor((secs % 86400) / 3600)).padStart(2, '0');
      if (m) m.textContent = String(Math.floor((secs % 3600) / 60)).padStart(2, '0');
      if (s) s.textContent = String(secs % 60).padStart(2, '0');
    }
    tick();
    var timer = setInterval(tick, 1000);
  });

  /* ---------- reviews: badge click scrolls to Judge.me widget ----------
     Capture-phase interception (element handlers can't swallow the click) +
     a per-frame target lock. CRITICAL detail: the reviews node is RE-RESOLVED
     every frame -- Judge.me's app hydration can replace the element, and a
     detached node reports position 0, which silently poisons any held
     reference. If the element is missing/detached/zero-size, the lock pins to
     the document bottom instead (the reviews sit directly above the footer).
     "Done" requires both alignment AND a quiet page height. */
  function p61ScrollToReviews() {
    var scroller = document.scrollingElement || document.documentElement;
    var HEADER = 90;
    var t0 = Date.now();
    var SMOOTH_MS = 650, PROTECTED_MS = 1500, TOTAL_MS = 8000;
    var released = false, stableFrames = 0, lastHeight = 0;

    function getTarget() {
      // Prefer the ACTUAL Judge.me widget by its widget classes; consider any
      // id-bearing candidates too. If several exist (theme placeholder and
      // app block once shared an id), take the LAST substantial one in
      // document order -- the real widget renders content, decoys don't.
      var candidates = Array.prototype.slice.call(document.querySelectorAll(
        '.jdgm-widget-revamp, .jdgm-rev-widg, #judgeme_product_reviews, #theme-reviews-anchor'
      ));
      var best = null;
      for (var i = 0; i < candidates.length; i++) {
        var el = candidates[i];
        if (!el.isConnected) continue;
        var r = el.getBoundingClientRect();
        if (r.height >= 40) best = el;            // substantial: real widget
        else if (!best && r.width > 0) best = el; // placeholder only if nothing better
      }
      return best;
    }
    function instantTo(y) {
      var root = document.documentElement;
      var prev = root.style.scrollBehavior;
      root.style.scrollBehavior = 'auto';
      scroller.scrollTop = Math.max(0, y);
      root.style.scrollBehavior = prev;
    }
    function desiredY() {
      var el = getTarget();
      if (el) return scroller.scrollTop + el.getBoundingClientRect().top - HEADER;
      return scroller.scrollHeight - window.innerHeight; // top of the footer
    }

    var initial = getTarget();
    if (window.console && console.info) console.info('[P61] reviews scroll engaged; target:', initial ? 'live element' : 'footer fallback');
    document.documentElement.setAttribute('data-p61-scroll', initial ? 'locked' : 'footer-fallback');

    function release() { if (Date.now() - t0 >= PROTECTED_MS) released = true; }
    function keyRelease(ev) {
      if ([' ', 'ArrowUp', 'ArrowDown', 'PageUp', 'PageDown', 'Home', 'End'].indexOf(ev.key) > -1) release();
    }
    window.addEventListener('wheel', release, { passive: true });
    window.addEventListener('touchmove', release, { passive: true });
    window.addEventListener('keydown', keyRelease);

    if (initial) { try { initial.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (err) { instantTo(desiredY()); } }
    else instantTo(desiredY());

    function tick() {
      var elapsed = Date.now() - t0;
      if (released || elapsed > TOTAL_MS) { cleanup('released'); return; }
      if (elapsed > SMOOTH_MS) {
        var delta = desiredY() - scroller.scrollTop;
        var heightNow = scroller.scrollHeight;
        if (Math.abs(delta) > 4 || heightNow !== lastHeight) {
          if (Math.abs(delta) > 4) instantTo(scroller.scrollTop + delta);
          stableFrames = 0;
          lastHeight = heightNow;
        } else if (++stableFrames > 60 && elapsed > PROTECTED_MS + 1000) {
          cleanup('done'); return;
        }
      }
      requestAnimationFrame(tick);
    }
    function cleanup(state) {
      document.documentElement.setAttribute('data-p61-scroll', state);
      window.removeEventListener('wheel', release);
      window.removeEventListener('touchmove', release);
      window.removeEventListener('keydown', keyRelease);
    }
    requestAnimationFrame(tick);
  }
  window.P61ScrollToReviews = p61ScrollToReviews;

  document.addEventListener('click', function (e) {
    if (e.target.closest('#judgeme_product_reviews, .jdgm-widget-revamp, .jdgm-rev-widg')) return;
    var badge = e.target.closest(
      '.product-info__jdgm, .product-info__rating, .product-info__meta .shopify-app-block, ' +
      '.product-info .jdgm-preview-badge, .product-info .jdgm-prev-badge, .product-info .jm-star-rating, ' +
      '.product-info [class*="jm-badge"], .product-info [class*="preview-badge"]'
    );
    if (!badge) return;
    if (window.console && console.info) console.info('[P61] star badge click captured on:', badge.className || badge.tagName);
    e.preventDefault();
    e.stopImmediatePropagation();
    p61ScrollToReviews();
  }, true);

  /* ---------- collection switcher tabs ---------- */
  document.addEventListener('click', function (e) {
    var tab = e.target.closest('[data-cswitch-tab]');
    if (!tab) return;
    var root = tab.closest('[data-cswitch]');
    if (!root) return;
    var idx = tab.getAttribute('data-cswitch-tab');
    root.querySelectorAll('[data-cswitch-tab]').forEach(function (t) { t.classList.toggle('is-active', t === tab); });
    root.querySelectorAll('[data-cswitch-panel]').forEach(function (p) {
      p.hidden = p.getAttribute('data-cswitch-panel') !== idx;
    });
  });

  /* ---------- featured product section (PDP-style picker) ---------- */
  document.querySelectorAll('[data-featured-product]').forEach(function (root) {
    var dataEl = root.querySelector('[data-fp-variants]');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (err) { return; }
    var priceEl = root.querySelector('[data-fp-price]');
    var compareEl = root.querySelector('[data-fp-compare]');
    var atc = root.querySelector('[data-fp-atc]');
    var qtyInput = root.querySelector('[data-fp-qty]');
    var idInput = root.querySelector('[data-fp-id]');
    var sectionEl = root.closest('.featured-product');
    var frame = sectionEl ? sectionEl.querySelector('[data-gallery]') : null;
    var galleryApi = frame ? frame.__galleryApi : null;

    function vOpt(v, i) { return v['option' + (i + 1)] !== undefined ? v['option' + (i + 1)] : (v.options ? v.options[i] : null); }
    function selectedOptions() {
      var out = [];
      root.querySelectorAll('.option-values').forEach(function (group) {
        var checked = group.querySelector('input:checked');
        out.push(checked ? checked.value : null);
      });
      return out;
    }
    function apply(variant) {
      if (!variant) return;
      if (idInput) idInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      var showCompare = window.theme.showCompareAt === true && variant.compare_at_price && variant.compare_at_price > variant.price;
      if (compareEl) {
        compareEl.hidden = !showCompare;
        if (showCompare) compareEl.textContent = formatMoney(variant.compare_at_price);
      }
      if (priceEl) priceEl.classList.toggle('sale', showCompare);
      if (atc) {
        atc.disabled = !variant.available;
        var label = atc.querySelector('.btn-label');
        if (label) label.textContent = variant.available ? 'Add to cart' : 'Sold out';
      }
      if (galleryApi && (variant.featured_media || variant.featured_image)) galleryApi.selectByVariant(variant);
    }

    root.addEventListener('change', function (e) {
      if (!e.target.matches('input[type="radio"]')) return;
      var opts = selectedOptions();
      var variant = variants.find(function (v) {
        return opts.every(function (o, i) { return o === null || vOpt(v, i) === o; });
      });
      apply(variant);
    });

    if (atc) {
      atc.addEventListener('click', function () {
        var id = idInput ? idInput.value : (variants[0] && variants[0].id);
        var qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
        if (id) addToCart(id, qty, atc);
      });
    }
  });

  /* ---------- title star badge from Judge.me's own data payload ----------
     Reads jdgm.data.reviewWidget[productId] (published by the v2025 widget)
     and renders the theme's own badge: fractional-fill stars + editable text.
     Coverage checks are VISIBILITY-based: hidden legacy markup (display:none
     preview badges, unpopulated app blocks) no longer suppresses the badge.
     If no data arrives, falls back to the section's static rating line. */
  (function () {
    var holder = document.querySelector('.product-info__jdgm[data-id]');
    if (!holder) return;
    var productId = holder.getAttribute('data-id');
    var textTemplate = holder.getAttribute('data-badge-text') || 'Rated [rating] stars by pilots';
    var fallbackText = holder.getAttribute('data-fallback-text') || '';
    var tries = 0;

    function isVisible(el) {
      if (!el) return false;
      var r = el.getBoundingClientRect();
      return el.offsetParent !== null && r.height > 4 && r.width > 4;
    }

    function alreadyCovered() {
      // Our own render counts as covered
      if (holder.querySelector('.p61-stars')) return true;
      // Legacy script actually populated AND made the badge visible
      var legacy = holder.querySelector('.jdgm-prev-badge');
      if (legacy && isVisible(legacy)) return true;
      // A Judge.me app block in the meta row that is genuinely visible
      var blocks = document.querySelectorAll('.product-info__meta .shopify-app-block');
      for (var i = 0; i < blocks.length; i++) {
        if (blocks[i].textContent.trim() && isVisible(blocks[i])) return true;
      }
      return false;
    }

    function starsHtml(rating) {
      var pct = (Math.max(0, Math.min(5, rating)) / 5 * 100).toFixed(1);
      return '<span class="p61-stars" aria-hidden="true">' +
        '<span class="p61-stars__base">\u2605\u2605\u2605\u2605\u2605</span>' +
        '<span class="p61-stars__fill" style="width:' + pct + '%">\u2605\u2605\u2605\u2605\u2605</span>' +
      '</span>';
    }

    function takeOver(state) {
      /* Judge.me's stylesheet hides .jdgm-preview-badge containers until ITS
         script initializes them (which never happens on migrated stores).
         Once the theme owns this element, remove their classes so their CSS
         can no longer match it, and force visibility inline. */
      holder.classList.remove('jdgm-widget', 'jdgm-preview-badge');
      holder.classList.add('p61-rating-badge');
      holder.style.display = 'inline-flex';
      holder.style.visibility = 'visible';
      holder.style.opacity = '1';
      holder.setAttribute('data-p61-state', state);
    }

    function renderBadge(avg, count) {
      var rating = parseFloat(avg) || 0;
      var text = textTemplate
        .replace('[rating]', rating.toFixed(1))
        .replace('[count]', String(count));
      holder.innerHTML = starsHtml(rating) + '<span class="p61-stars__text">' + escapeHtml(text) + '</span>';
      takeOver('live');
      holder.setAttribute('aria-label', 'Rated ' + rating.toFixed(1) + ' out of 5 stars. Jump to reviews.');
      holder.setAttribute('role', 'button');
      holder.setAttribute('tabindex', '0');
    }

    function renderFallback() {
      if (!fallbackText || alreadyCovered()) return;
      holder.innerHTML = starsHtml(5) + '<span class="p61-stars__text">' + escapeHtml(fallbackText) + '</span>';
      takeOver('fallback');
    }

    function attempt() {
      if (alreadyCovered()) return;
      var data = window.jdgm && window.jdgm.data && window.jdgm.data.reviewWidget && window.jdgm.data.reviewWidget[productId];
      if (data && typeof data.number_of_reviews !== 'undefined') {
        var count = parseInt(data.number_of_reviews, 10) || 0;
        if (count > 0) { renderBadge(data.average_rating, count); }
        else { renderFallback(); }
        return;
      }
      if (++tries < 20) { setTimeout(attempt, 250); }
      else { renderFallback(); }
    }
    attempt();
  })();
})();
